import './CheckoutApp.less';
import React, {useState, useEffect, useContext} from 'react';
import __ from "../../i18n";
import {Link, useParams} from "react-router-dom";
import useCourse from "../../hooks/useCourse";
import LoadingPlaceholder from "../../components/loading-placeholder/LoadingPlaceholder";
import AuthContext from "../../contexts/auth/AuthContext";
import ImageView from "../../components/image-view/ImageView";
import Button from "../../../bootstrap/components/button/Button";
import Toasts, {TOAST_ERROR} from "../../../bootstrap/scomponents/toasts/Toasts";
import Popup from "../../../bootstrap/components/popup/Popup";
import Request from "../../../bootstrap/api/Request";
import Spinner from "../../../bootstrap/components/spinner/Spinner";
import PaymentMethodDialog from "../../dialogs/payment-method/PaymentMethodDialog";
import routes from "../../routing/routes";
import Icon from "../../../bootstrap/components/icon/Icon";
import LibraryEnrollParcel from "../../api/endpoints/library/LibraryEnrollParcel";


export default function CheckoutApp() {

    const authContext = useContext(AuthContext);

    const user = authContext.user;

    const params = useParams();

    const type = params['type'];

    const id = parseInt(params['id']);

    const [course, refs, isLoading] = useCourse(id, ['image', 'promotion']);
    
    const [isEnrolling, setIsEnrolling] = useState(false);
    
    const [enrollmentId, setEnrollmentId] = useState(null);
    
    const [paymentDialogShown, setPaymentDialogShown] = useState(false);

    const handlePaymentButtonClick = () => {
        if (enrollmentId !== null) {
            setPaymentDialogShown(true);
            return;
        }

        if (isEnrolling) {
            return;
        }

        setIsEnrolling(true);

        Request.add(new LibraryEnrollParcel(course.id))
            .then(data => {
                setEnrollmentId(data.id);
                setPaymentDialogShown(true);
            })
            .catch(error => {
                Toasts.add(TOAST_ERROR, error.getMessage());
            })
            .finally(() => {
                setIsEnrolling(false);
            });
    };

    if (isLoading) {
        return <LoadingPlaceholder/>;
    }

    if (course === null) {
        return null;
    }

    const avatarImage = refs.images.find(t => t.id === course.avatar_image_id);

    const promotion = refs.promotions.find(t => t.id === course.promotion_id);

    let salePrice = course.price;
    if (promotion) {
        salePrice = Math.floor(course.price * (100 - promotion.discount_percentage) / 100);
    }

    return <div className="checkout-app">
        <div className="inner">
            <div className="header">
                <h1 className="title">{__('Checkout')}</h1>
                <div className="description">{__('Please review your order')}</div>
            </div>
            <div className="content-section">
                <h3 className="subtitle">{__('Order details')}</h3>
                <div className="content">
                    <div className="course-item">
                        <Icon name="tick-circle"/>
                        <div className="main">
                            <div className="info">
                                <Link className="avatar" to={routes.course.getUrl(course.slug)}>
                                    <ImageView image={avatarImage} ratio={1.5}/>
                                </Link>
                                <div className="name">
                                    <Link to={routes.course.getUrl(course.slug)}>{course.name}</Link>
                                </div>
                            </div>
                            <div className="price">{__('::price(CURRENCY)', {price: salePrice})}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content-section">
                <h3 className="subtitle">{__('Your information')}</h3>
                <div className="content">
                    <div className="user-name">{user.full_name}</div>
                    <div className="email">{user.email}</div>
                </div>
            </div>
            <div className="content-section">
                <Button
                    title={isEnrolling ? __('Processing...') : __('Complete payment')}
                    appearance={isEnrolling ? "text-primary" : "solid-primary"}
                    size="large"
                    onClick={() => handlePaymentButtonClick()}
                    icon={isEnrolling ? <Spinner size={1}/> : null}
                />
            </div>
        </div>
        {
            enrollmentId !== null &&
            paymentDialogShown &&
            <Popup
                title={__('Payment method')}
                close={() => setPaymentDialogShown(false)}
            >
                <PaymentMethodDialog
                    instruction={__('You can transfer with the information below to complete your payment. After that, your course will be activated on the system for you to start learning.')}
                    bankTransferContent={__('DKKH ::id', {id: enrollmentId})}
                    amount={salePrice}
                />
            </Popup>
        }
    </div>;
}
